export default {"src":"/_next/static/media/logo-16.e5a44efb.svg","height":51,"width":46,"blurWidth":0,"blurHeight":0};